export enum BotDifficulty {
    Easy = 0,
    Medium = 1,
};
